import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const EUProgramSection = () => {
  const programDetails = [
  {
    id: 1,
    title: 'Interreg IPA Cross-border Cooperation',
    description: 'Supporting cross-border cooperation between EU and candidate countries',
    duration: '2022-2025'
  },
  {
    id: 2,
    title: 'European Heritage Days Initiative',
    description: 'Promoting cultural heritage awareness and accessibility',
    duration: '2023-2024'
  },
  {
    id: 3,
    title: 'Digital Europe Programme',
    description: 'Digital transformation of heritage tourism services',
    duration: '2023-2026'
  }];


  const certifications = [
  {
    id: 1,
    name: 'EU Quality Label',
    logo: "https://images.unsplash.com/photo-1675855508248-83b25370ff61",
    logoAlt: 'European Union quality certification emblem with blue background and golden stars'
  },
  {
    id: 2,
    name: 'Heritage Excellence',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1554a3513-1763207626821.png",
    logoAlt: 'Heritage Excellence certification badge with classical architectural elements and quality seal'
  },
  {
    id: 3,
    name: 'Sustainable Tourism',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1ba966cd2-1763207625097.png",
    logoAlt: 'Sustainable Tourism certification logo featuring green leaf and environmental protection symbols'
  },
  {
    id: 4,
    name: 'Cross-Border Cooperation',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_14ff8b5a4-1763207627208.png",
    logoAlt: 'Cross-Border Cooperation program emblem with interconnected regions and partnership symbols'
  }];


  const euProjectLogos = [
  {
    id: 1,
    name: 'EU Funding',
    src: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763512232/Flag_of_Europe.svg_ku7fyb.png",
    alt: 'European Union co-financing logo indicating EU support for cross-border cooperation project',
    link: 'https://european-union.europa.eu/index_en'
  },
  {
    id: 2,
    name: 'CBC Serbia-Montenegro',
    src: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763512227/CBC-SRB-MNE-logo-2014_2020-beli_rhls3s.png",
    alt: 'Cross-Border Cooperation Serbia-Montenegro program logo for 2014-2020 period',
    link: null
  },
  {
    id: 3,
    name: 'Serbia Coat of Arms',
    src: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763512232/Coat_of_arms_of_Serbia_small.svg_f7vhbg.png",
    alt: 'Official coat of arms of the Republic of Serbia with national heraldic symbols',
    link: null
  },
  {
    id: 4,
    name: 'Montenegro Coat of Arms',
    src: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763512231/Coat_of_arms_of_Montenegro.svg_s0bops.png",
    alt: 'Official coat of arms of Montenegro featuring national eagle and crown symbols',
    link: null
  }];



  return (
    <div className="bg-card rounded-lg shadow-card p-8 mb-8">
      <div className="text-center mb-8">
        <h2 className="font-heading font-semibold text-2xl text-foreground mb-3">
          EU Program Support & Funding
        </h2>
        <p className="text-muted-foreground max-w-2xl mx-auto">
          This project is proudly supported by European Union funding programs dedicated to 
          heritage preservation, cross-border cooperation, and sustainable tourism development.
        </p>
      </div>

      {/* EU Project Logos Section */}
      <div className="mb-8">
        <h3 className="font-heading font-semibold text-lg text-foreground mb-6 text-center">
          Supported By
        </h3>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 justify-items-center">
          {euProjectLogos?.map((logo) => {
            const logoElement =
            <div key={logo?.id} className="bg-white rounded-lg p-4 shadow-sm hover:shadow-md transition-shadow duration-fast">
                <div className="h-16 w-24 flex items-center justify-center">
                  <Image
                  src={logo?.src}
                  alt={logo?.alt}
                  className="h-full w-full object-contain" />

                </div>
              </div>;


            return logo?.link ?
            <a
              key={logo?.id}
              href={logo?.link}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:opacity-80 transition-opacity duration-300">

                {logoElement}
              </a> :
            logoElement;
          })}
        </div>
        
        {/* EU Project Disclaimer */}
        <div className="mt-6 pt-6 border-t border-border">
          <div className="bg-primary/5 rounded-lg p-6 text-center">
            <p className="text-sm text-muted-foreground leading-relaxed">
              Projekat je sufinansiran od strane Evropske unije u okviru IPA II programa prekogranične saradnje Srbija - Crna Gora (2014-2020).
            </p>
          </div>
        </div>
      </div>

      {/* Funding Programs */}
      <div className="mb-8">
        <h3 className="font-heading font-semibold text-lg text-foreground mb-4">
          Funding Programs
        </h3>
        <div className="grid md:grid-cols-3 gap-4">
          {programDetails?.map((program) =>
          <div key={program?.id} className="bg-surface rounded-lg p-4">
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                  <Icon name="Euro" size={16} className="text-primary" />
                </div>
                <div className="flex-1">
                  <h4 className="font-medium text-sm text-foreground mb-1">
                    {program?.title}
                  </h4>
                  <p className="text-xs text-muted-foreground mb-2 leading-relaxed">
                    {program?.description}
                  </p>
                  <div className="flex items-center justify-end text-xs">
                    <span className="text-muted-foreground">{program?.duration}</span>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* EU Certifications */}
      <div className="pt-6 border-t border-border">
        <h3 className="font-heading font-semibold text-lg text-foreground mb-4">
          Official Certifications
        </h3>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {certifications?.map((cert) =>
          <div key={cert?.id} className="text-center">
              <div className="w-20 h-14 mx-auto mb-2 rounded-lg overflow-hidden bg-muted">
                <Image
                src={cert?.logo}
                alt={cert?.logoAlt}
                className="w-full h-full object-cover" />

              </div>
              <p className="text-xs text-muted-foreground font-medium">
                {cert?.name}
              </p>
            </div>
          )}
        </div>
      </div>

      {/* EU Disclaimer */}
      <div className="mt-6 pt-6 border-t border-border">
        <div className="bg-primary/5 rounded-lg p-4">
          <div className="flex items-start gap-3">
            <Icon name="Info" size={20} className="text-primary flex-shrink-0 mt-0.5" />
            <div className="text-sm text-muted-foreground">
              <p className="mb-2">
                This project is co-funded by the European Union under the Interreg IPA Cross-border 
                Cooperation Programme. The content represents the views of the authors only and is 
                their sole responsibility.
              </p>
              <p>
                The European Commission does not accept any responsibility for use that may be made 
                of the information it contains.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>);

};

export default EUProgramSection;